import BaseService from 'services/BaseService';

export default class AnchorService extends BaseService {
	_type = 'anchor';
	_typeKey = 'category';
}
